import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ship, Loader2 } from "lucide-react";
import { api } from "@/api/client";
import { StatusBadge } from "@/components/RequirementStatus";

export function MyRanksPanel() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/requirements/mine").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="my-ranks-panel">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Ship className="w-4 h-4 text-slate-500" />
          <div className="text-sm font-semibold text-slate-800">My Ranks</div>
        </div>
        <div className="text-xs text-slate-400" data-testid="my-ranks-count">{items ? `${items.length} assigned` : ""}</div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full crew-table">
          <thead>
            <tr>
              <th className="text-left">Vessel</th>
              <th className="text-left">Rank</th>
              <th className="text-left">Required</th>
              <th className="text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {items === null && (
              <tr><td colSpan={4} className="text-center py-8"><Loader2 className="w-4 h-4 animate-spin text-slate-400 inline" /></td></tr>
            )}
            {items?.length === 0 && (
              <tr><td colSpan={4} className="text-center text-slate-400 py-8" data-testid="my-ranks-empty">No ranks assigned to you yet</td></tr>
            )}
            {items?.map((r) => (
              <tr key={r.id} data-testid={`my-rank-row-${r.id}`}>
                <td className="font-medium text-slate-800">
                  <Link to={`/vessels/${r.vessel_id}`} className="hover:text-cyan-700 transition-colors" data-testid={`my-rank-vessel-link-${r.id}`}>{r.vessel_name}</Link>
                </td>
                <td className="text-slate-700">{r.rank}</td>
                <td className="font-mono text-slate-700">{r.required_count}</td>
                <td><StatusBadge status={r.status} testid={`my-rank-status-${r.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
